/**
 * Adds animation class to text elements when they enter the viewport.
 * Supports sequential animation via data-animate-delay attribute.
 */
document.addEventListener('DOMContentLoaded', () => {
    const animatedElements = document.querySelectorAll('.animate-on-scroll, .animate-on-scroll-slower, .animate-x-from-left-on-scroll, .animate-x-from-right-on-scroll');

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const el = entry.target;
                    // Read delay from data-animate-delay attribute (in ms)
                    const delay = el.getAttribute('data-animate-delay');
                    if (delay) {
                        el.style.transitionDelay = `${parseInt(delay, 10)}ms`;
                    }
                    el.classList.add('animated');
                    obs.unobserve(el);
                }
            });
        }, { threshold: 0.1 });

        animatedElements.forEach(el => observer.observe(el));
    } else {
        // Fallback: show all if IntersectionObserver not supported
        animatedElements.forEach(el => el.classList.add('animated'));
    }
});
